import { render, staticRenderFns } from "./dialog-asset-allocation.vue?vue&type=template&id=92fba94e&scoped=true&"
import script from "./dialog-asset-allocation.vue?vue&type=script&lang=js&"
export * from "./dialog-asset-allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fba94e",
  null
  
)

export default component.exports